import { render, staticRenderFns } from "./DisplayInfo.vue?vue&type=template&id=aa98ec1e&scoped=true"
import script from "./DisplayInfo.vue?vue&type=script&lang=js"
export * from "./DisplayInfo.vue?vue&type=script&lang=js"
import style0 from "./DisplayInfo.vue?vue&type=style&index=0&id=aa98ec1e&prod&lang=scss&scoped=true"
import style1 from "./DisplayInfo.vue?vue&type=style&index=1&id=aa98ec1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa98ec1e",
  null
  
)

export default component.exports